import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IInvestmentsState } from "./slice";
import { getInvestmentsAsync } from "./actions";

type Reducer = (builder: ActionReducerMapBuilder<IInvestmentsState>) => void;

export const getInvestmentsReducer: Reducer = (builder) => {
  builder.addCase(getInvestmentsAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getInvestmentsAsync.fulfilled, (state, actions) => {
    state.isLoading = false;
    state.data = actions.payload;
  });

  builder.addCase(getInvestmentsAsync.rejected, (state) => {
    state.isLoading = false;
    state.data = [];
  });
};

